import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TextLabel = function TextLabel(_ref) {
  var label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      x = _ref.x,
      height = _ref.height,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical;
  var node = useRef();

  var _useState = useState({
    elHeight: 0,
    elWidth: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      elSize = _useState2[0],
      setElSize = _useState2[1];

  useEffect(function () {
    var elHeight = node.current.getBoundingClientRect().height;
    var elWidth = node.current.getBoundingClientRect().width;
    setElSize({
      elHeight: elHeight,
      elWidth: elWidth
    });
  }, []);
  var elHeight = elSize.elHeight,
      elWidth = elSize.elWidth;
  var xTransform = vertical ? -height + 3 : x + 3;
  var yTransform = vertical ? x + elHeight + 3 : height - 2;
  var transform = vertical ? "scale(-1,1)" : ''; // const xTransform = vertical ? x + elHeight + 3 : x + 3;
  // const transform = vertical ? `rotate(270, ${xTransform}, ${height})` : ''

  return /*#__PURE__*/_jsxs("g", {
    children: [/*#__PURE__*/_jsx("rect", {
      transform: transform,
      x: xTransform,
      y: yTransform - elHeight + 3,
      width: elWidth,
      height: elHeight,
      style: {
        stroke: 'none'
      }
    }), /*#__PURE__*/_jsx("text", {
      ref: node,
      transform: transform,
      x: xTransform,
      y: yTransform,
      className: className,
      children: label
    })]
  });
};

TextLabel.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  x: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  vertical: PropTypes.bool
};
export default TextLabel;